export const fanpageConnectionsMessages = {
  title: 'Fanpage kết nối',
  fanpage: 'Fanpage',
  source: 'Nguồn',
  integrateFanpage: 'Tích hợp fanpage',
  refresh: 'Làm mới'
};
